module.exports = __webpack_public_path__ + "img/empresasconfianza.c9e9560f.png";